
import { List, ImagePreview, Popup } from 'vant'
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
import { jsSdk } from '../../../assets/libs/loadjs';
// 引入高德地图
// import AMap from 'AMap';

export default {
  name: 'home',
  components: {
    [List.name]: List,
    [ImagePreview.name]: ImagePreview,
    [Popup.name]: Popup
  },
  data () {
    return {
      // 标记是否是查询,用于在没有数据时显示不同的文案
      isQuery: false,
      // 标题
      photoAlbumTitle: '',
      // 查询条件
      // 相册类型
      photoType: [],
      // 当前页码
      nowPage: 1,
      // 每页数量
      onePageNumber: this.$store.state.onePageNumber ? this.$store.state.onePageNumber : 20,
      // 摄像头类型
      cameraType: null,
      // 开始日期
      startTime: null,
      // 结束日期
      endTime: null,
      // 照片数据
      count: 0,
      photoList: [],
      // 上拉刷新
      loading: false,
      finished: false,
      // 播放视频
      showVideo: false,
      videoUrl: '',
      // 封面
      videoThumb: '',
      // 预览照片(用于异步关闭)
      instance: null,
      // 分享有关
      // 当前查看的图片/视频的列表id(用于分享)
      shareID: '',
      // 当前查看的图片缩略图(用于分享)
      imgThumb: '',
      isshow:false,
      show:false,
      url_thumb:'',
      isangle: window.orientation == 90 || window.orientation == -90,
    }
  },
  methods: {
    initPhotoListFn (isFirst) {
      let _this = this;
      if (isFirst) {
        this.$toast.loading({
          overlay: true,
          duration: 0,
          message: '加载中...'
        });
      }
      this.$axios.post('/v3/u/album/listV2', {
        type: this.photoType,
        limit: this.onePageNumber,
        page: this.nowPage,
        camera: this.cameraType,
        startTime: (new Date(this.startTime)).getTime(),
        endTime: (new Date(this.endTime)).getTime()
      })
        .then((response)=>{
          // console.log(response);
          if (response.data.ret === 0) {
            // 加载状态结束
            this.loading = false;
            let reqData = response.data.data.data;
            if (reqData && reqData.length > 0) {
              this.count = response.data.data.total;
              this.groupPhotoListFn(reqData);

            }
            // 判断是否还有数据
            if (this.onePageNumber > reqData.length) {
              this.finished = true;
            }
            this.$toast.clear();
          } else {
            this.finished = true;
            this.$toast.clear();
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取相册信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch( (error)=>{
          this.finished = true;
          this.$toast.clear();
          errorModal(error, 151);
        })
    },
    // 照片数据格式处理以及根据日期分组
    groupPhotoListFn (resData) {
      const data = resData.map(item => {
        return {
          ...item,
          finishTimeShow: getTime.getTimeText(1, item.create_time),
        }
      })
       // 根据时间同一天分组
       const sameDay = Array.from(new Set(data.map(item => item.finishTimeShow)));
       const sortData = sameDay.reduce((total,item)=>{
         const getSameDayData = data.filter(itm=>itm.finishTimeShow === item);
         total.push({
           finishTimeShow:item,
           children:getSameDayData,
         })
         return total;
       },[])
       // 新数据添加到原数据
       this.photoList = this.photoList.concat(sortData);
    },


    // 上拉加载
    onLoad () {
      this.nowPage = this.nowPage + 1;
      this.initPhotoListFn();
    },
    // 预览照片
    previewImageFn (groupIndex, imgIndex) {
      let imgData = this.photoList[groupIndex].children;
      let imgArray = [];
      // 分享相关
      this.shareID = imgData[imgIndex]._id;
      this.imgThumb = imgData[imgIndex].url_thumb;
      this.shareTitle = this.$store.state.customerName + '图片分享';
      this.shareSetFn();
      for (let i = 0; i < imgData.length; i++) {
        imgArray.push(imgData[i].url);
      }
      // ImagePreview(imgArray);
      let _this = this;
      const instanceImagePreview = ImagePreview({
        images: imgArray,
        startPosition: imgIndex,
        onChange: function (nowIndex) {
          _this.shareID = imgData[nowIndex]._id;
          _this.imgThumb = imgData[nowIndex].url_thumb;
          _this.shareSetFn();
        },
        onClose: function () {
          _this.shareTitle = '';
          _this.imgThumb = '';
          _this.shareSetFn();
        }
      });
      this.instance = instanceImagePreview;
    },
    // 播放视频
    playVideoFn (url, thumb, listID) {
      this.videoUrl = url;
      this.videoThumb = thumb;
      this.showVideo = true;
      // let vdo = document.getElementById('playVideos');
      // vdo.src = url;
      // 分享相关
      this.shareID = listID;
      this.shareTitle = this.$store.state.customerName + '视频分享';
      this.shareSetFn();
    },
    // 点击遮罩层时触发
    clickOverlay () {
      this.videoUrl = '';
      this.videoThumb = '';
      this.shareTitle = '';
      this.shareSetFn();
    },
    // 自定义分享
    shareSetFn () {
      let _this = this;
      // 查询字段
      let queryField = '_id';
      // 链接域名
      let baseLink = window.location.origin;
      // 分享链接
      let shareLink = this.shareTitle ? (baseLink + '/showMedia?' + queryField + '=' + _this.shareID + '&customer=' + _this.$store.state.customer + '&share=share') : baseLink + '/photoList?type=' + this.photoType[0] + '&share=share';
      // 分享图标
      let shareImgUrl = this.imgThumb || this.videoThumb;
      jsSdk(this.$store.state.customer, ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']).then(function(){
        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
        wx.updateAppMessageShareData({
          title: _this.shareTitle || document.title, // 分享标题
          desc: baseLink, // 分享描述
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('PhotoList - 设置成功111');
          },
          fail:function(res){
            // ios报错:the permission value is offline verifying
            // ios报错:updateAppMessageShareData:the permission value is offline verifying
            console.log('PhotoList - fail:' + JSON.stringify(res));
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
        wx.updateTimelineShareData({
          title: _this.shareTitle || document.title, // 分享标题
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('PhotoList - 设置成功222');
          },
          fail:function(res){
            console.log('PhotoList - fail-two:' + JSON.stringify(res));
          }
        });
        // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）(兼容IOS)
        wx.onMenuShareAppMessage({
          title: _this.shareTitle || document.title,
          desc: baseLink,
          link: shareLink,
          imgUrl: shareImgUrl,
          type: '',
          dataUrl: '',
          success: function () {
            // 用户点击了分享后执行的回调函数
            console.log('PhotoList - 分享成功111');
          }
        });
        // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）(兼容IOS)
        wx.onMenuShareTimeline({
          title: _this.shareTitle || document.title,
          link: shareLink,
          imgUrl: shareImgUrl,
          success: function () {
            // 用户点击了分享后执行的回调函数
            console.log('PhotoList - 分享成功222');
          }
        });
      });
    },
    change3DImg(id='demoVideo'){
      if(this.selfitem.mtype === 1){
        this.create3DImg('demo4d')
      }else if(this.selfitem.mtype===2){
        this.change3DVideo('demo4d')
      }
    },
    create3DImg(id='demoVideo'){
      this.player = new EapilRender(document.getElementById(id),{
          DataType: EapilRender.DATATYPE.IMG,
          SourceUrl:this.selfitem.url,
          Template: localStorage.getItem('cameraTemplate')
        });
    },
    change3DVideo(id){
      this.player = new EapilRender(document.getElementById(id), {
        // poster: this.selfitem.url_thumb,
        poster: '',
        DataType: EapilRender.DATATYPE.MP4,
        RoateXY: { "xValue": 0, "yValue": 0 },
        SourceUrl: this.selfitem.url,
        Template: localStorage.getItem('cameraTemplate'),
      });
    },
    fullScreenHandle(item,type){
      this.selfitem = item;
      this.url_thumb = item.url_thumb;
      this.show = true;
      // window.scroll(0,0);
      // document.body.style.overflow = 'hidden'
      // this.isshow = true;


      // this.$nextTick(()=>{
      //   if(type === 1){
      //     this.creat3DImg(item,'demoVideo')
      //   }else if(type===2){
      //     this.change3DVideo(item,'demoVideo')
      //   }

      // })
    },
    closeHandle(){
        document.body.style.overflow = 'auto'
        try {
          this.player.destroy()
        } catch (error) {
          document.getElementById('demo4d').innerHTML = ''
        }
        this.isshow = false;
    },
    actionHandle(){
      this.isangle = screen.orientation.angle === 90;
    },
  },
  mounted () {
    // 获取页面传参
    let photoType = this.$route.query.type;
    let cameraType = parseInt(this.$route.query.camera);
    let startTime = this.$route.query.startTime;
    let endTime = this.$route.query.endTime;

      const listPhotoType = [{
        type: [7],
        labelKey:["realtime_photo"],
        name: "实时照片",
        hasData:false,
        label: "realtime_photo",
    },{
        type: [8],
        labelKey:["realtime_video"],
        name: "实时视频",
        label: "realtime_video",
    }, {
        type: [11, 12],
        name: "停车报警",
        labelKey:["accOff_photo","accOff_video"],
        label: "park_photo_video",
    },{
        type: [5, 6, 15, 16],
        name: "行车碰撞",
        hasData:false,
        labelKey:["lock_photo","lock_video","lock_video_banma","lock_photo_banma"],
        label: "lock_photo_video_banma",
    }, {
        type: [14],
        name: "紧急视频",
        hasData:false,
        labelKey:["sos_video"],
        label: "sos_video",
    },{
        type: [3, 4, 21 ,22],
        name: "设备抓拍",
        hasData:false,
        labelKey:["voice_photo","voice_video","key_press_capture_photo","key_press_capture_video"],
        label: "voice_photo_video",
    }]
    const photoAlbum =  listPhotoType.find(item=>item.type.join(",").includes(photoType));

    if (photoType) {
      this.photoType = photoType.split(",").map(Number);
      this.photoAlbumTitle = photoAlbum.name;
      this.cameraType = cameraType || null;
      this.startTime = startTime || null;
      this.endTime = endTime || null;
      this.isQuery = startTime;
      this.initPhotoListFn('first');
      this.shareSetFn();
    } else {
      this.$notify({
        message: '参数错误',
        duration: 0,
        background: '#ff3300'
      })
    }
    window.addEventListener("orientationchange",this.actionHandle,false);
  },
  destroyed () {
    window.removeEventListener('orientationchange',this.actionHandle);
    this.$notify.clear();
    // 异步关闭图片预览
    if (this.instance) {
      this.instance.close();
    }
  }
}
